import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  basicDetails: {
    code: '',
    name: '',
    benefitType: '',
    status: 'ACTIVE',
    description: '',
    imageUrl: '',
    autoRenew: false,
    providerPackageIds: []
  }
};

export const ValueAddedServiceSlice = createSlice({
  name: 'valueAddedService',
  initialState,
  reducers: {
    setBasicDetails: (state, action) => {
      state.basicDetails = { ...state.basicDetails, ...action.payload };
    },
    setField: (state, action) => {
      const { field, value } = action.payload;
      state.basicDetails[field] = value;
    },
    setProviderPackages: (state, action) => {
      state.basicDetails.providerPackageIds = action.payload;
    },
    reset: () => initialState,
  },
});

export const {
  setBasicDetails,
  setField,
  setProviderPackages,
  reset,
} = ValueAddedServiceSlice.actions;

export default ValueAddedServiceSlice.reducer;
